import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import moment from 'moment';

import { CATEGORIES, DESCRIPTION_LIMIT } from './LicenseConstants';
import FieldGroupComponent from '../../core/FieldGroupComponent/FieldGroupComponent';
import { ENVIRONMENTS } from '../../../constants/common';

import './licenseForm.scss';

class LicenseFormComponent extends React.Component {
    componentWillMount() {
        !this.props.inProgress && this.props.reset();
    }

    render() {
        const {
            isCreateAction,
            description,
            initialValues,
            platforms,
            selectedPlatform,
            toolTipFlag,
            changePlatform,
        } = this.props;
        const {
            consumerKey,
            consumerSecret,
            env,
            license,
            prodDate,
        } = initialValues;

        return <Form>
            {toolTipFlag && <span className="toolTip">Licenses moved to Production are active and editable in Dev environment.</span>}
            <FieldGroupComponent
                label="App Name"
                name="name"
                type="text"
                formProps={{
                    maxLength: 100,
                }}
            />
            {isCreateAction && <FieldGroupComponent
                label="Enrollment Type"
                name="platform"
                placeholder="Select"
                type="select"
                formProps={{
                    id: 'platform',
                    options: platforms,
                }}
                onChange={changePlatform}
            />}
            {!isCreateAction && <span>
                <div>
                    <h5>Enrollment Type</h5>
                    <span>{selectedPlatform}</span>
                </div>
                <div>
                    <h5>License Number</h5>
                    <span>{license}</span>
                </div>
                {consumerKey && <div>
                    <h5>OAuth Client ID</h5>
                    <span>{consumerKey}</span>
                </div>}
                {consumerSecret && <div>
                    <h5>OAuth Client Secret</h5>
                    <span>{consumerSecret}</span>
                </div>}
            </span>}
            <FieldGroupComponent
                label="Category"
                name="category"
                placeholder="Select"
                type="select"
                formProps={{
                    id: 'category',
                    options: CATEGORIES,
                }}
            />
            <FieldGroupComponent
                label="Redirect URL"
                name="redirectUrl"
                type="text"
            />
            {!isCreateAction && env === ENVIRONMENTS.prod && <span>
                <div>
                    <h5>Production Date</h5>
                    {prodDate && <span>{moment(prodDate).format('MMM DD, YYYY').valueOf()}</span>}
                    {!prodDate && <span>{moment().format('MMM DD, YYYY').valueOf()}</span>}
                </div>
            </span>}
            <FieldGroupComponent
                className="description"
                label="Description"
                name="description"
                placeholder="Enter a description about your app."
                type="textarea"
                formProps={{
                    componentClass: 'textarea',
                    maxLength: DESCRIPTION_LIMIT,
                }}
            />
            <span className="description-limit">
                You have {DESCRIPTION_LIMIT - description.length} character(s) left.
            </span>
        </Form>;
    }
}

LicenseFormComponent.defaultProps = {
    description: '',
};

LicenseFormComponent.propTypes = {
    isCreateAction: PropTypes.bool.isRequired,
    description: PropTypes.string,
    selectedPlatform: PropTypes.string,
    initialValues: PropTypes.object.isRequired,
    platforms: PropTypes.array.isRequired,
    toolTipFlag: PropTypes.bool,
    reset: PropTypes.func,
    inProgress: PropTypes.bool,
    changePlatform: PropTypes.func,
};

export default LicenseFormComponent;



// WEBPACK FOOTER //
// ./src/components/profile/License/LicenseFormComponent.js